import { render, staticRenderFns } from "./DesktopCenterTab.vue?vue&type=template&id=147fddda&"
import script from "./DesktopCenterTab.vue?vue&type=script&lang=js&"
export * from "./DesktopCenterTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports